import React from 'react'
import { useTranslation } from 'react-i18next'
import { H5 } from '@fs/zion-ui'
import DataView from '../../common/DataView'
import { getIdElement } from '../../../util/StringUtil'

export default function UserAliases({ aliases }) {
  const data = []
  const [t] = useTranslation()

  if (!aliases) return null

  const ALIASES_FIELD_NAMES = [
    { name: 'cisId', label: t('cisId', 'CIS ID') },
    { name: 'contributorId', label: t('userId', 'User ID') },
  ]

  const populateView = () => {
    aliases.forEach((alias) => {
      ALIASES_FIELD_NAMES.forEach((field) => {
        data.push({
          label: field.label,
          detail: getIdElement(alias[field.name]),
        })
      })
      data.push({
        label: '',
        detail: '',
      })
    })
  }

  populateView()

  return (
    <>
      <H5>{t('user.aliases', 'User Aliases')}</H5>
      <DataView data={data} />
      <br />
    </>
  )
}
